import React from 'react'
import QuestionWithRubricForm from '../common/question-with-rubric-form/QuestionWithRubricForm'
import { useDispatch, useSelector } from 'react-redux'
import { rubricPersistSelectors } from '../../../../../../../store/selectors/rubric.persist.selectors'
import { rubricPersistActions } from '../../../../../../../store/slices/rubric.persist.slice'
import { useParams } from 'react-router'
import { useBatchUpdateQuestionsMutation } from '../../../../../../../store/apis/question.api'
import { openNotificationWithIcon } from '../../../../../../../utils/notification.helper'
import { store } from '../../../../../../../../index'

const QuestionReviewStep = () => {
    const { token } = useParams()
    const questions = useSelector(rubricPersistSelectors.questions(token))
    const rubricQuestions = useSelector(rubricPersistSelectors.rubricQuestions(token))
    const unmatchedValuesPerQuestion = useSelector(rubricPersistSelectors.unmatchedValuesPerQuestion(token))
    const currentStep = useSelector(rubricPersistSelectors.currentStep(token))
    const dispatch = useDispatch()

    const [batchUpdateQuestions, batchUpdateQuestionsResult] = useBatchUpdateQuestionsMutation()

    const question = questions[currentStep - 3]

    const rubricQuestionIndex = rubricQuestions.findIndex(rubricQuestion => rubricQuestion.id == question.rubric.id)
    const unmatchedRubricValues = unmatchedValuesPerQuestion.map((subArray, subArrayIndex) =>
        subArray.map((value, index) => ({
            content: value,
            id: `${subArrayIndex}-${index}`,
        })),
    )

    const nextStepExists = currentStep < questions.length + 2

    const handleSave = async values => {
        if (nextStepExists) {
            dispatch(rubricPersistActions.saveQuestion({ token, id: question.id, reviewed: values }))
            dispatch(rubricPersistActions.nextStep({ token }))
        } else {
            dispatch(
                rubricPersistActions.saveQuestion({
                    token,
                    id: question.id,
                    reviewed: values,
                }),
            )

            const response = await batchUpdateQuestions({
                token,
                questions: store.getState().rubricPersist[token].questions.map(q => ({
                    //using store.getState() to get the latest state resulted by the previous dispatch
                    id: q.id,
                    ...q.reviewed,
                })),
            })
            if ('data' in response) {
                dispatch(rubricPersistActions.resetAssignment({ token }))
                openNotificationWithIcon('success', 'Saved successfully')
            }
        }
    }

    return (
        <QuestionWithRubricForm
            key={currentStep}
            unmatchedRubricValues={unmatchedRubricValues}
            unmatchedRubricValuesIndex={rubricQuestionIndex}
            rubricValues={question.rubric}
            originalValues={question}
            reviewedValues={question.reviewed}
            onSubmit={handleSave}
            submitButtonText={nextStepExists ? 'Save & Next' : 'Save & Finish'}
            loading={batchUpdateQuestionsResult.isLoading}
            error={batchUpdateQuestionsResult.error}
        />
    )
}

export default QuestionReviewStep
